
import { loadMessages, locale } from 'devextreme/localization';
//import '@/assets/fonts/Roboto-Regular-normal.js'

//import { jsPDF } from 'jspdf';
import 'jspdf-autotable'

// nf 20231008 Libraries for export
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridToPdf} from 'devextreme/pdf_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter'

//
const customMessages = {
    en: {
        'Yes': 'Ναι',
        'No': 'Όχι',
        'dxDataGrid-editingConfirmDeleteMessage': 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την εγγραφή;',
        'dxDataGrid-trueText': 'Ναι',
        'dxDataGrid-falseText': 'Όχι',
    },
    // ... Other languages can be added as needed
};

// Then in your Vue's `onMounted` or another appropriate lifecycle hook:
loadMessages(customMessages);
locale('en');  // replace 'en' with your preferred locale if different

const Host =  {
    URI : 'https://webapp.nautilia-yachting.com/data/api.php/records/',
    APIRoot : 'https://webapp.nautilia-yachting.com/data/api.php/',
    URIUpload : 'https://webapp.nautilia-yachting.com/data/file-upload.php',
    URIUploadFolderCharterBases : 'https://nautilia-yachting.com/images/charter-bases/',
}
console.log('Host', Host)
/*
let host = location.host
let path = location.pathname

if (host.includes('localhost')) {
    host = "https://nautilia-yachting.com/"
}

const Host =  {
    URI : 'https://' + host + path + '/data/api.php/records/',
    APIRoot : 'https://' + host + path + '/data/api.php/',
}
*/

const loggedUser = {}
const logoLoginImageSource = 'nautilia/logo-login-screen.png'
const logoMainImageSource = 'nautilia/logo-main.png'

const googleMapsAPIKey = 'AIzaSyAVWVfAtI1Rbt97G9F6UWiVWj7gHGuw-MI'

export default {
    Host,
    loggedUser,
    logoLoginImageSource,
    logoMainImageSource,
    customMessages,
    googleMapsAPIKey,

    methods: { 
        exportDataGridToPdfExcel(e, reportTitle, columnWidths = [40]){
            //console.log(e)
            if (e.format === 'xlsx') {
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Main sheet');
                exportDataGrid({
                    component: e.component,
                    worksheet: worksheet,
                    customizeCell: function(options) {
                        options.excelCell.font = { name: 'Arial', size: 12 };
                        options.excelCell.alignment = { horizontal: 'left' };
                    } 
                }).then(function() {
                    workbook.xlsx.writeBuffer()
                        .then(function(buffer) {
                            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), reportTitle + '.xlsx');
                        });
                });
                e.cancel = true;
            } 
            else if (e.format === 'pdf') {
                const doc = new jsPDF()
                doc.setFont('Roboto-Regular')

                // Add a title to the document
                doc.setFontSize(16) // Set font size as per your requirement
                doc.text(reportTitle, 10, 17) // Adjust x, y coordinates as needed
                doc.setFontSize(8)

                exportDataGridToPdf({
                    jsPDFDocument: doc,
                    component: e.component,
                    indent: 15,
                    margin: { top: 20, right: 10, bottom: 10, left: 10 },
                    columnWidths: columnWidths,
                    customizeCell: function(options) {
                        const {gridCell, pdfCell} = options
                        pdfCell.font.size = 7;
                        pdfCell.font.style = 'normal';
                        if (gridCell.rowType === 'data' && gridCell.column.dataType === 'boolean') {
                            pdfCell.text = gridCell.value ? 'Ναι' : 'Όχι';
                        }
                    },
                }).then(() => {

                    const totalPages = doc.internal.getNumberOfPages();
                    const imageURL = logoMainImageSource //"path/to/your/image.png";  // URL or Base64 encoded string

                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();
                    const footerYPosition = pageHeight - 10;

                    const imageWidth = 10;  // The width you want the image to be displayed as
                    const imageHeight = 5;
                    
                    // Calculate the x-coordinate for right alignment
                    const imageXPosition = pageWidth - imageWidth - 10;  // Subtracting an additional 10 for a small margin from the edge
                    const imageYPosition = 10 - imageHeight;

                    const currentDate = new Date();

                    // Format the date in Greek
                    const formattedDate = new Intl.DateTimeFormat('el-GR', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}).format(currentDate);

                    for (let i = 1; i <= totalPages; i++) {
                        doc.setPage(i);

                        //Header
                        doc.addImage(imageURL, 'PNG', imageXPosition, imageYPosition, imageWidth, imageHeight, "logo"); // Adjust the y-coordinate and height as needed

                        doc.setFontSize(8);
                        //doc.text(reportTitle, 10, headerYPosition); // Adjust x, y coordinates as needed
                        doc.text(reportTitle, 10, imageYPosition + 3); 
                        doc.setFontSize(8);

                        doc.setDrawColor(200, 200, 200)
                        //doc.line(10, headerYPosition + lineOffset, pageWidth - 10, headerYPosition + lineOffset);
                        doc.line(10, 10, pageWidth - 10, 10)

                        // Add "Page x of y" at the bottom
                        const pageLabelText = `Σελίδα ${i} από ${totalPages}`;
                        const pageLabelWidth = doc.getStringUnitWidth(pageLabelText) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                        const pageLabelX = pageWidth - pageLabelWidth - 10; // right alligned position

                        //const dateLabelWidth = doc.getStringUnitWidth(formattedDate) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                        const dateLabelX = 10 //pageWidth - dateLabelWidth - 10; // Centered position
                        
                        doc.line(10, footerYPosition, pageWidth - 10, footerYPosition)
                        doc.text(formattedDate, dateLabelX, footerYPosition + 4)
                        doc.text(pageLabelText, pageLabelX, footerYPosition + 4)

                        doc.setDrawColor(128, 128, 128)
                    }
                
                    doc.save(reportTitle + '.pdf')
                })
            }
        }

    }
}
